var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"custom-classes-transition","enter-active-class":"animated bounceInDown","leave-active-class":"animated fadeOut"}},[(_vm.msgInfo.isShow)?_c('div',{staticClass:"sw-info"},[_c('i',{staticClass:"sw-info-icon"},[_vm._v("!")]),_c('div',{staticClass:"sw-info-msg"},[_vm._v(_vm._s(_vm.msgInfo.msg))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }